const REMEMBERED_CREDS_KEY = "ecliptica.rememberedCreds";

function parseJson(value) {
  if (!value) return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_err) {
    return {};
  }
}

function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch (_err) {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (_err) {
    // ignore storage write failures
  }
}

function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch (_err) {
    // ignore storage write failures
  }
}

export function readRememberedAuth() {
  const stored = parseJson(safeGet(REMEMBERED_CREDS_KEY));
  if (typeof stored.email === "string" && stored.email.trim()) {
    const emailOnly = { email: stored.email.trim() };
    if ("password" in stored) {
      safeSet(REMEMBERED_CREDS_KEY, JSON.stringify(emailOnly));
    }
    return emailOnly;
  }
  safeRemove(REMEMBERED_CREDS_KEY);
  return {};
}

export function writeRememberedAuth({ email }) {
  const safeEmail = String(email || "").trim();
  if (!safeEmail) {
    safeRemove(REMEMBERED_CREDS_KEY);
    return;
  }
  safeSet(REMEMBERED_CREDS_KEY, JSON.stringify({ email: safeEmail }));
}

export function clearRememberedAuth() {
  safeRemove(REMEMBERED_CREDS_KEY);
}
